module.exports = __webpack_public_path__ + "img/fram-check.9e4c1391.svg";